import React from "react";
import NnMenus from "../nav/NnMenus";
import NnSong from "./NnSong";
import "./NnSongPanel.scss";

export default class NnSongPanel extends React.Component {
  render() {
    const {letters, position, song, timing, title} = this.props;
    let notes = song ? song.notes : [];
    const opts = {...this.props};
    opts.songId = song && song.id;
    return (
      <div className="song-panel" id="song-panel-x">
        <div className="nn-logo">
          <a href="https://numberednotes.com/">&nbsp;</a>
        </div>

        <div className="song-info">
          <div className="song-title">{title}</div>

          {/* This area contains the NotesTiming and Lyrics information */}
          <NnSong
            displayTiming={timing}
            displayLetters={letters}
            position={position}
            notes={notes}
          />

          {/* This is the play results, i.e percent correct */}
          <div className="song-results">
            <span>Score: {this.props.scorePercentage}%</span>
          </div>
        </div>

        <NnMenus {...this.props}/>

      </div>
    );
  }
}
